import React from 'react';
import { Box } from '@mui/material';

import TabContent from './TabContent';
import StudyTabContent from './StudyTabContent';
import { PostTypes } from '../../../../../../Utils/Types';
import PostStepShow from '../../../../../PostStepShow/PostStepShow';

function TabContainer({ post, stepTab }: any) {
  return (
    <>
      <Box
        sx={{
          mb: 3,
          px: { xs: 1, sm: 2 },
        }}
      >
        <PostStepShow step={stepTab} />
      </Box>

      {post.type === PostTypes.STUDY ? (
        <StudyTabContent post={post} stepTab={stepTab} />
      ) : (
        <TabContent post={post} stepTab={stepTab} />
      )}
    </>
  );
}

export default TabContainer;
